import { render, staticRenderFns } from "./subDetail.vue?vue&type=template&id=2857b5f9&"
import script from "./subDetail.vue?vue&type=script&lang=js&"
export * from "./subDetail.vue?vue&type=script&lang=js&"
import style0 from "./subDetail.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports